module.exports = __webpack_public_path__ + "static/media/camera-L.inline.69f6498d.svg";